<div class="terms-container">
  <div class="terms-content">
    <h1 class="terms-title">Terms and Conditions</h1>

    <section class="terms-section">
      <h2 class="section-title">1. Introduction</h2>
      <p>
        Welcome to Stitch ("we," "us," or "our"). These Terms and Conditions ("Terms") govern your use of our website located at https://stitch.agi.supply (the "Website") and our services provided through the Website (collectively, the "Services").
      </p>
      <p>
        By accessing or using our Services, you agree to be bound by these Terms. If you disagree with any part of these Terms, you may not access the Services.
      </p>
      <p>
        These Terms apply to all users of the Website, including without limitation users who are browsers, vendors, customers, merchants, and/or contributors of content.
      </p>
    </section>

    <section class="terms-section">
      <h2 class="section-title">2. Use of Our Services</h2>
      <h3 class="subsection-title">2.1 Eligibility</h3>
      <p>
        To use our Services, you must be at least 18 years old and have the legal capacity to enter into these Terms. By using our Services, you represent and warrant that you meet these requirements.
      </p>

      <h3 class="subsection-title">2.2 Account Registration</h3>
      <p>
        Some features of our Services may require you to create an account. When you create an account, you must provide accurate and complete information. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
      </p>

      <h3 class="subsection-title">2.3 Acceptable Use</h3>
      <p>
        You agree not to use our Services to:
      </p>
      <ul class="terms-list">
        <li>Violate any applicable laws or regulations</li>
        <li>Infringe on the rights of others</li>
        <li>Transmit harmful, offensive, or inappropriate content</li>
        <li>Attempt to gain unauthorized access to our systems</li>
        <li>Interfere with the proper functioning of our Services</li>
        <li>Use automated tools or scripts without our permission</li>
      </ul>
    </section>

    <section class="terms-section">
      <h2 class="section-title">3. Intellectual Property</h2>
      <h3 class="subsection-title">3.1 Our Content</h3>
      <p>
        All content on our Website, including but not limited to text, graphics, logos, images, audio clips, video clips, data compilations, and software, is the property of Stitch or our licensors and is protected by copyright, trademark, and other intellectual property laws.
      </p>

      <h3 class="subsection-title">3.2 Your Content</h3>
      <p>
        By submitting content to our Services, you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, adapt, publish, translate, distribute, and display such content in connection with our Services.
      </p>
    </section>

    <section class="terms-section">
      <h2 class="section-title">4. Privacy and Data Protection</h2>
      <p>
        Your privacy is important to us. Our collection and use of personal information is governed by our Privacy Policy, which is incorporated into these Terms by reference. By using our Services, you consent to the collection and use of your information as outlined in our Privacy Policy.
      </p>
    </section>

    <section class="terms-section">
      <h2 class="section-title">5. Disclaimers and Limitations of Liability</h2>
      <h3 class="subsection-title">5.1 Service Availability</h3>
      <p>
        We strive to provide reliable Services, but we do not guarantee that our Services will be uninterrupted, error-free, or available at all times. We reserve the right to modify, suspend, or discontinue our Services at any time without notice.
      </p>

      <h3 class="subsection-title">5.2 Limitation of Liability</h3>
      <p>
        To the maximum extent permitted by law, Stitch shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting from your use of our Services.
      </p>

      <h3 class="subsection-title">5.3 Disclaimer of Warranties</h3>
      <p>
        Our Services are provided "as is" and "as available" without warranties of any kind, either express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, and non-infringement.
      </p>
    </section>

    <section class="terms-section">
      <h2 class="section-title">6. Termination</h2>
      <p>
        We may terminate or suspend your access to our Services immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach these Terms.
      </p>
      <p>
        Upon termination, your right to use our Services will cease immediately. All provisions of these Terms which by their nature should survive termination shall survive, including, without limitation, ownership provisions, warranty disclaimers, and limitations of liability.
      </p>
    </section>

    <section class="terms-section">
      <h2 class="section-title">7. Governing Law</h2>
      <p>
        These Terms shall be governed and construed in accordance with the laws of the jurisdiction in which Stitch operates, without regard to its conflict of law provisions.
      </p>
      <p>
        Any disputes arising from these Terms shall be resolved through binding arbitration in accordance with the rules of the appropriate arbitration association.
      </p>
    </section>

    <section class="terms-section">
      <h2 class="section-title">8. Changes to Terms</h2>
      <p>
        We reserve the right to modify these Terms at any time. We will notify users of any material changes by posting the updated Terms on our Website and updating the "Last Updated" date.
      </p>
      <p>
        Your continued use of our Services after such modifications constitutes acceptance of the updated Terms.
      </p>
    </section>

    <section class="terms-section">
      <h2 class="section-title">9. Contact Information</h2>
      <p>
        If you have any questions about these Terms, please contact us at support email address.
      </p>
      <p>
        Stitch
      </p>
    </section>
  </div>
</div>
